import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { Question, QuestionOption } from '../../../../_models';
import * as _ from 'lodash';
import { QuestionType } from '../../../../_enums';

@Component({
  selector: 'app-question-type-matching',
  templateUrl: './question-type-matching.component.html',
  styleUrls: ['./question-type-matching.component.scss']
})
export class QuestionTypeMatchingComponent implements OnInit {

  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup; settings: Settings;
  @Input('viewOnly') viewOnly = false;

  constructor(
    private fb: FormBuilder,
    public appSettings: AppSettings,
  ) {
    this.settings = this.appSettings.settings;
  }

  get options(): FormArray {
    if (!this.formGroup)
      return null;
    return this.formGroup.get('options') as FormArray;
  }

  ngOnInit() {
    this.formGroup.reset();
    this.formGroup.addControl('options', this.fb.array([]));
    this.options.controls.length = 0;

    if (!this.question || this.question.questionType !== QuestionType.Matching ||
      !this.question.options || this.question.options.length === 0) {
      this.options.push(this.createOptionFormItem(null));
      this.options.push(this.createOptionFormItem(null));
    } else {
      _.forEach(this.question.options, o => this.options.push(this.createOptionFormItem(o)));
    }

    if (this.viewOnly)
      this.formGroup.disable();
  }
  createOptionFormItem(option: QuestionOption): FormGroup {
    return this.fb.group({
      id: option ? option.questionOptionId : 0,
      title: [option ? option.title : '', [Validators.required]],
      matchTitle: [option ? option.matchTitle : '', [Validators.required]],
    });
  }
  removeOption() {
  }
  addOption() {

  }
}
